import { EsriMapComponent } from "@flexo/atoms";
import { InformationCard } from '../information-card/information-card';

import styles from './rows-wrapper.module.scss';

export default function RowsWrapper(props: any){

    const { items } = props;
    
    return (
        <div className={styles.RowsWrapper}>
            {
                ( items || [])
                .filter((item: any) => item?.keep !== false)
                .map((item: any, itemKey: number) => {
                    if ( item.type === 'card' ) {
                        return (
                            <div key={`${item.type}-${itemKey}`} className={item?.className || ''}>
                                <InformationCard {...item} />
                            </div>
                        )
                    } else if ( item.type === 'map' ) {
                        return (
                            <div key={`${item.type}-${itemKey}`} className={item?.className || ''}>
                                <EsriMapComponent {...item} />
                            </div>
                        )
                    } else {
                        return '';
                    }
                            
                
                })
            }
        </div>
    )
}
